import { type } from "@testing-library/user-event/dist/type";
import React, { useEffect } from "react";
import { setContrast } from "./ColorSwap.js";

function ProductGroups({
  primaryColor,
  selectedProductGroup,
  setSelectedProductGroup,
  productGroups,
  resizeIframe,
}) {
  const defaultAmountsLenToWidth = {
    1: "w-full",
    2: "w-1/2",
    3: "w-1/3",
    4: "w-1/4",
    5: "w-1/5",
    6: "w-1/6",
    7: "w-1/7",
    8: "w-1/8",
  };

  useEffect(() => {
    resizeIframe();
  }, [productGroups]);

  return (
    <div>
      <div className="space-y-1">
        {productGroups.map((productGroup, i) => {
          return (
            <button
              type="button"
              className={
                "h-10 w-full rounded-md border bg-indigo-600 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              }
              onClick={(e) => setSelectedProductGroup(productGroup)}
              style={
                selectedProductGroup !== undefined &&
                selectedProductGroup.productGroupName !== "" &&
                selectedProductGroup.productGroupName ===
                  productGroup.productGroupName
                  ? {
                      backgroundColor: primaryColor,
                      color: setContrast(primaryColor),
                    }
                  : { backgroundColor: "white", color: "gray" }
              }
              //   value={productGroup.amount}
            >
              <div className="grid grid-cols-12 items-center text-lg">
                {/* <div className="col-span-2 justify-self-start pl-2 pr-2.5">
                  $
                  {productGroup.amount >= 1000
                    ? (+productGroup.amount / 1000).toFixed(1) + "K"
                    : productGroup.amount}
                </div> */}
                {/* <div className="col-span-1"> - </div> */}
                <div className="col-span-12 justify-self-start pl-2 pr-2.5 text-left">
                  <div className="-mt-1 text-base">
                    {productGroup.productGroupName}
                  </div>
                  <div className="-mt-[3px] text-2xs">
                    {productGroup.productGroupDescription}
                  </div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ProductGroups;
